import React, { memo } from 'react';
import Macro from "../../utils/ReplaceMacro";
const OverviewTab = ({selectedStore}) => {

  return (
    <div className="tab-pane fade active in" id="tab-1">
      <h4>Summary</h4>
      <p className='lead'>
        <Macro input={selectedStore?.summary} />
      </p>
    <h4>Description</h4>
    <p className="lead">
      <Macro input={selectedStore?.description} />
    </p>
  </div>
  )
}

export default memo(OverviewTab);
